import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import useActiveMerchantId from "src/hooks/use-merchant-id";
import merchantProvider from "src/providers/merchant-provider";

const PAGE_SIZE = 50;

const requireMerchantId = (merchantId: string | null): string => {
	if (!merchantId) {
		throw new Error("Merchant ID is required");
	}
	return merchantId;
};

const customersQueries = {
	listCustomers: () => {
		const { merchantId } = useActiveMerchantId();

		return useInfiniteQuery({
			queryKey: ["listCustomers", merchantId],
			queryFn: ({ pageParam }) =>
				merchantProvider.listCustomers(requireMerchantId(merchantId), {
					limit: PAGE_SIZE,
					cursor: pageParam?.cursor || "",
					reverseOrder: true,
				}),
			initialPageParam: { cursor: "" },
			staleTime: Infinity,
			enabled: Boolean(merchantId),
			getNextPageParam: (lastPage) => {
				if (!lastPage.cursor) {
					return undefined;
				}
				return { cursor: lastPage.cursor };
			},
			retry: 2,
		});
	},

	getCustomer: () => {
		const { merchantId } = useActiveMerchantId();

		return useMutation({
			mutationFn: (customerId: string) =>
				merchantProvider.getCustomerDetails(
					requireMerchantId(merchantId),
					customerId,
				),
		});
	},
};

export default customersQueries;
